t = require('app/scripts/views/internal/teacup-with-helpers')('calendar_toolbar')

module.exports = ->
  t.div '.calendar-header', ->

    t.div '.calendar-header-toolbar', ->

      t.div '.calendar-header-toolbar-nav', ->

        t.button '.button.icon-button.js-left-arrow.left-arrow', { href: '#' }, ->
          t.icon 'up'

        t.button '.button.today-button.js-today', { href: '#' }, ->
          t.format 'today'

        t.button '.button.icon-button.js-right-arrow.right-arrow', { href: '#' }, ->
          t.icon 'down'

      t.h2 '.calendar-header-toolbar-title.js-calendar-header'

      t.div '.calendar-header-toolbar-type', ->

        t.button '.button.js-week-view.week-button', { href: '#' }, ->
          t.format 'week'

        t.button '.button.js-month-view.month-button', { href: '#' }, ->
          t.format 'month'

       t.div '.calendar-header-toolbar-right', ->
        t.a '.icon-lg.icon-gear.dark-hover.js-calendar-settings', { href: '#' }
        t.a '.icon-lg.icon-close.dark-hover.js-close-calendar', { href: '#' }

    t.div '.days-of-week', ->
      t.mustacheBlock 'days', ->
        t.div '.quiet', ->
          t.text t.mustacheVar('.')

  t.div '.calendar-content'
